import { objOf, propOr } from "ramda";
import { useMyMutation, useMyQuery } from "../Authorization/reactQueryWrappers";
import { SaveableNote } from "../SaveableNote/SaveableNote";

export const ClientNotes = ({ username, userId = username, unsavedRef }) => {
  const query = useMyQuery({
    queryKey: ["coach-user-note", username],
    fetchDef: {
      url: `/api/latest/coach-user-note/${username}`,
    },
    /* {
      "coachId": "petr.cocah@dummy.com",
      "userId": "jakub.user2@dummy.com",
      "note": "note1"
    } */
  });
  const mutation = useMyMutation({
    fetchDef: {
      method: "POST",
      url: `/api/latest/coach-user-note/${userId}`,
    },
    invalidate: {
      queryKey: ["coach-user-note", username],
    },
  });

  return (
    <SaveableNote
      query={query}
      to={propOr("", "note")}
      mutation={mutation}
      from={objOf("note")}
      unsavedRef={unsavedRef}
    />
  );
};
